import Box from "@mui/material/Box";
import { lazy, Suspense } from "react";
import Stack from "@mui/material/Stack";
import MainCard from "../Layouts/MainCard";
import ExerciseEntity from "./ExerciseEntity";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { getAthleteCardio } from "../../api/user";
import { useAuth } from "../../context/AuthContext";
import useScreenSize from "../../context/ScreenContext";
import TableChartIcon from "@mui/icons-material/TableChart";
import {
  MainTitle,
  SpacedRow,
  scrollBar,
  CenteredRow,
  MainText,
} from "../../data/style/Style";

const Loader = lazy(() => import("./Loader"));
const NoDataDiv = lazy(() => import("./NoDataDiv"));
const AbilitiesModal = lazy(() => import("../Modals/AblitiesModal"));

const Cardio = ({ showExerciseDetails }) => {
  const { mobileDevice } = useScreenSize();
  const { user } = useAuth();

  const { data, isPending } = useQuery({
    queryKey: ["abilities", "cardio", user.id],
    queryFn: ({ signal }) => getAthleteCardio({ signal }),
    staleTime: 30 * 60 * 1000,
  });

  return (
    <Box flex={1} minWidth={"270px"}>
      <MainCard start={Theme.palette.up} middle={Theme.palette.up}>
        {!isPending ? (
          <>
            <SpacedRow alignItems={"center"}>
              <CenteredRow gap={1}>
                <MainText fontSize={"1.2rem"}>🏃</MainText>
                <MainTitle mobile={mobileDevice}>Cardio</MainTitle>
              </CenteredRow>
              <Suspense>
                <AbilitiesModal type={"cardio"} color={Theme.palette.up} />
              </Suspense>
            </SpacedRow>
            {data.length > 0 ? (
              <Stack p={0.5} height={"30vh"} sx={scrollBar} overflow={"auto"}>
                {data.map((item) => (
                  <ExerciseEntity
                    key={item.id}
                    item={item}
                    showExerciseDetails={showExerciseDetails}
                    type={"cardio"}
                  />
                ))}
              </Stack>
            ) : (
              <Suspense>
                <NoDataDiv
                  height={"30vh"}
                  minHeight={"160px"}
                  text={"No data available. Start tracking your progress."}
                  icon={
                    <TableChartIcon
                      sx={{
                        fontSize: mobileDevice ? "3rem" : "4rem",
                        color: Theme.palette.up,
                      }}
                    />
                  }
                />
              </Suspense>
            )}
          </>
        ) : (
          <Suspense>
            <Loader height={"35vh"} minHeight={"100px"} />
          </Suspense>
        )}
      </MainCard>
    </Box>
  );
};

export default Cardio;
